'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    $('[data-cart-continue-button]').on('click', function () {
        var selectedValue = $('input[name=DeliveryTypesId]:checked', '#deliveryTypeForm').val();

        if (selectedValue === undefined) {

            $('#deliveryTypeErrorMessage').html('<span class="field-validation-error"><span class="">' + Resx.App.DeliveryTypeMustBeSelected + '</span></span>');
        } else {
            $('#deliveryTypeErrorMessage').html('');
            $('#deliveryTypeForm').submit();
        }
    });

    $('#deliveryTypeForm input[type=radio]').on('click', function () {
        $('#deliveryTypeErrorMessage').html('');
        var price = Number($(this).attr('data-price'));
        var priceWithVat = Number($(this).attr('data-price-with-vat'));
        var vat = new Number($(this).attr('data-price-vat'));

        var deliveryRowVat = getNumberFromCurrency($('[delivery-row]').find('td').eq(2).text());
        var deliveryRowPrice = getNumberFromCurrency($('[delivery-row]').find('td').eq(3).text());
        var deliveryRowPriceWithVat = getNumberFromCurrency($('[delivery-row]').find('td').eq(4).text());
        $('[delivery-row]').remove();

        var summaryRow = $('[summary-row]');
        var summaryVat = getNumberFromCurrency($(summaryRow).find('td').eq(2).text()) - deliveryRowVat + vat;
        var summaryPrice = getNumberFromCurrency($(summaryRow).find('td').eq(3).text()) - deliveryRowPrice + price;
        var summaryPriceWithVat = getNumberFromCurrency($(summaryRow).find('td').eq(4).text()) - deliveryRowPriceWithVat + priceWithVat;

        $('#summaryTable > tbody').prepend('<tr delivery-row>\n                <td>' + Resx.App.Transportation + '</td>\n                <td>1</td>\n                <td>' + getDisplayValue(vat) + '</td>\n                <td>' + getDisplayValue(price) + '</td>\n                <td>' + getDisplayValue(priceWithVat) + '</td>\n            </tr>');

        $('[summary-row]').find('td').eq(2).html(getSummaryRowDisplayValue(summaryVat));
        $('[summary-row]').find('td').eq(3).html(getSummaryRowDisplayValue(summaryPrice));
        $('[summary-row]').find('td').eq(4).html(getSummaryRowDisplayValue(summaryPriceWithVat));
    });

    function checkNaN(value) {
        if (isNaN(value)) {
            return 0;
        }
        return value;
    }

    function getNumberFromCurrency(value) {
        value = value.replace(",", ".");
        var val = Number(value.replace(/[^0-9$.,]/g, ""));
        return checkNaN(val);
    }

    function getDisplayValue(value) {
        if (value % 1 !== 0) {
            return value.toFixed(2).replace('.', ',') + ' ' + Resx.App.Currency;
        } else {
            return value + ' ' + Resx.App.Currency;
        }
    }
    function getSummaryRowDisplayValue(value) {
        return '<strong><span class="text-nowrap">' + getDisplayValue(value) + '</span></strong>';
    }
};

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");

var Resx = (0, _localize2.default)('Common', 'App');

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/cartDeliveryTypeSelect.js
// module id = 929
// module chunks = 0